import { observable, action, runInAction } from 'mobx';
import { redirectTo } from 'utils';
import { logout, getUserInfo } from '../services';

export default class GlobalStore {
    @observable isLogin = false; // 是否登录
    @observable loading = false;

    @observable
    accountInfo = {}; // 账号信息（姓名，权限等）

    @action
    getUserInfo = async () => {
        // 获取用户信息
        const data = await getUserInfo();
        runInAction(() => {
            if (data.code == 0) {
                this.isLogin = true;
                this.accountInfo = data.data;
            } else {
                this.isLogin = false;
                this.accountInfo = {};
                setTimeout(() => {
                    redirectTo();
                }, 1000);
            }
        });
    };

    @action
    logout = async () => {
        // 登出
        const data = await logout();
        if (data.code == 0) {
            runInAction(() => {
                this.isLogin = false;
            });
            redirectTo();
        }
    };

    @action
    showLoading() {
        this.loading = true;
    }

    @action
    hideLoading() {
        this.loading = false;
    }
}
